<div dir="{{ languageDir }}">
  <div class="production-db-content">
    <div class="content-top-box">
      <app-bread-crumb></app-bread-crumb>
      <div class="title-row-flex-both-end">
        <h1 class="main-title">
          {{ t('ChecklistExceptionReport', 'Checklist Exception Report') }}
        </h1>
      </div>
    </div>

    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)"
      template=" <img src='assets/images/spinner.gif' />"></ngx-spinner>

    <form [formGroup]="HeaderForm">
      <div class="content-top-row content-top-row-order-processing">

        <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
          appearence="fill">
          <mat-label>{{ t('Line', 'Line') }} *</mat-label>
          <mat-select formControlName="Line" [multiple]="true" [(ngModel)]="HeaderData.Line"
            ngxMatSelect #msf2="ngxMatSelect" [displayMember]="'PL_Desc'" [valueMember]="'PL_Id'"
            [source]="LineList" [useInfiniteScroll]="true" [placeholder]="'Search Line'">
            <mat-option #allSelectedLine (click)="toggleAllSelectionLine(allSelectedLine)"
              value="ALL">ALL</mat-option>
            <mat-option [value]="item.PL_Id" *ngFor="let item of msf2.filteredSource"
              (click)="tosslePerOneLine(allSelectedLine)">
              {{ item.PL_Desc }}
            </mat-option>
          </mat-select>
          <mat-error>{{ t('LineisRequired', 'Line is required') }}</mat-error>
        </mat-form-field>

        <div class="inputField">
          <nz-date-picker readonly
            nzFormat="dd-MMM-yyyy HH:mm" [nzShowTime]="{ nzFormat: 'HH:mm' }" [nzMin]="minDate"
            [nzMax]="maxDate" [nzDisabledDate]="disabledStartDate"
            [(ngModel)]="HeaderData.StartDate"
            formControlName="StartDate"></nz-date-picker>
          <span class="floating-text">{{ t('StartDate', 'Start Date') }} *</span>
        </div>

        <div class="inputField">
          <nz-date-picker readonly nzFormat="dd-MMM-yyyy HH:mm" [nzShowTime]="{ nzFormat: 'HH:mm' }"
            [nzMin]="minDate" [nzMax]="maxDate" [nzDisabledDate]="disabledEndDate"
            [(ngModel)]="HeaderData.EndDate" formControlName="EndDate">
          </nz-date-picker>
          <span class="floating-text">{{ t('EndDate', 'End Date') }} *</span>
        </div>

        <button type="button" class="search" tooltipPosition="top" (click)="getReport()"
          [disabled]="!hasAllFilters || isDateRangeReversed"
          *ngIf="isAccess | permissionChecker">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19.3609 18.2168L14.6008 13.2662C15.8247 11.8113 16.4953 9.98069 16.4953 8.07499C16.4953 3.62251 12.8728 0 8.4203 0C3.96782 0 0.345306 3.62251 0.345306 8.07499C0.345306 12.5275 3.96782 16.15 8.4203 16.15C10.0918 16.15 11.6847 15.6458 13.0466 14.6888L17.8428 19.677C18.0432 19.8852 18.3129 20 18.6018 20C18.8753 20 19.1348 19.8957 19.3317 19.7061C19.7502 19.3034 19.7636 18.6357 19.3609 18.2168ZM8.4203 2.10652C11.7114 2.10652 14.3888 4.78391 14.3888 8.07499C14.3888 11.3661 11.7114 14.0435 8.4203 14.0435C5.12921 14.0435 2.45183 11.3661 2.45183 8.07499C2.45183 4.78391 5.12921 2.10652 8.4203 2.10652Z"
              fill="#10123D" />
          </svg>
        </button>
      </div>

      <p class="filter-error" *ngIf="!hasAllFilters">
        {{ t('PleaseFillAllRequiredFields', 'Please fill all required fields') }}
      </p>

      <p class="filter-error" *ngIf="hasAllFilters && isDateRangeReversed">
        {{ t('StartDatemustbebeforeEndDate', 'Start Date must be before End Date') }}
      </p>
    </form>
  </div>

  <section>
    <div class="example-button-row">
      <span class="record-count" *ngIf="totalRows">
        {{ totalRows }} {{ t('Exceptions', 'exceptions') }}
      </span>
      <button *ngIf="isAccess | permissionChecker" type="button" class="btn btn-success"
        (click)="csvExport()" style="margin-top: 30px">
        <img src="assets/images/csv-file-format.png" />
      </button>
      <button *ngIf="isAccess | permissionChecker" type="button" class="btn btn-success"
        (click)="excelExport()" style="margin-top: 30px; margin-left: 10px">
        <i class="fa fa-file-excel-o icon-white" aria-hidden="true"></i>
      </button>
    </div>
  </section>

  <div class="grid-wrap">
    <ag-grid-angular style="width: 100%; height: 70vh; min-height: 420px" class="ag-theme-alpine"
      [rowData]="rowData"
      [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" (gridReady)="onGridReady($event)">
    </ag-grid-angular>

    <!-- paging is done in SQL, so the grid's own pagination stays off -->
    <mat-paginator [length]="totalRows" [pageSize]="pageSize" [pageIndex]="pageIndex"
      [pageSizeOptions]="pageSizeOptions" (page)="onPageChange($event)" showFirstLastButtons>
    </mat-paginator>
  </div>
</div>
